import {useState, useRef, useEffect} from 'react';

const useIntersectionObserver = (options, actionHandler) => {
  // const [isVisible, setIsVisible] = useState(false);
  const elRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting === true) {
        actionHandler();
        // setIsVisible(true);
      }
    }, options);

    if (elRef && elRef.current) {
      observer.observe(elRef.current);
    }

    return () => observer.disconnect();
  }, [elRef]);
  return [elRef];
};

export default useIntersectionObserver;
